import { api } from "./api.js";

/** POST /api/auth/register — creates the user and returns `{ user..., token }`. */
export const register = (payload) => api.post("/auth/register", payload);

/** POST /api/auth/login — returns `{ id, name, email, phone, role, token }`. */
export const login = (credentials) => api.post("/auth/login", credentials);

/** GET /api/auth/me — validates the stored token. */
export const me = () => api.get("/auth/me");

/** POST /api/auth/logout — advisory; the client discards the JWT regardless. */
export const logout = () => api.post("/auth/logout");

export default { register, login, me, logout };
